// This item ID normalization is based on:
// https://stackoverflow.com/questions/65021585/get-mime-mail-content-in-outlook-addin-via-graph

// For Graph API usage - needs URL-safe base64 encoding
export const getMailId = () => {
  let itemId = Office.context.mailbox.item?.itemId;

  if (!itemId) {
    return undefined;
  }

  // Handle "clientid:itemid:" prefix which can occur in some environments
  // If we don't strip this, convertToRestId might return it as-is (just safe-encoded), which Graph rejects.
  if (itemId.startsWith('clientid:itemid:')) {
    [, , itemId] = itemId.split(':');
  }

  // Use convertToRestId if available (Office requirement set 1.3+)
  // This handles converting EWS IDs to REST IDs
  if (Office.context.mailbox.convertToRestId) {
    return Office.context.mailbox.convertToRestId(itemId, Office.MailboxEnums.RestVersion.v2_0);
  }

  // fallback if convertToRestId is not available
  return itemId.replace(/\//g, '-').replace(/\+/g, '_');
};

// For EWS usage - needs original item ID format
export const getOriginalMailId = () => Office.context.mailbox.item?.itemId;
